import posthog from 'posthog-js'

export default {
    install(Vue, options = {}) {
        const apiKey = process.env.MIX_POSTHOG_API_KEY
        const host = process.env.MIX_POSTHOG_HOST || 'https://app.posthog.com'

        if (!apiKey) {
            console.warn('PostHog API Key not found. Tracking disabled.')
            return
        }

        posthog.init(apiKey, {
            api_host: host,
            autocapture: true,
            capture_pageview: false, // We handle this manually or via router if needed
            capture_performance: true,
            exception_autocapture: true, // Requested by user
            session_recording: {
                maskAllInputs: false,
                maskTextSelector: '.mask-text',
            },
            loaded: (ph) => {
                if (window.User) {
                    ph.identify(window.User.id, {
                        email: window.User.email,
                        name: window.User.name,
                        user_type: 'backoffice_user',
                    })

                    if (window.Tenant) {
                        ph.group('tenant', window.Tenant.id, {
                            domain: window.Tenant.domain,
                            name: window.Tenant.name || window.Tenant.id,
                        })
                    }
                }
            },
        })

        Vue.prototype.$posthog = posthog
    },
}
